import { setHasMoreMessages } from '@/redux/message/actions'
import { put } from 'redux-saga/effects'
import { loadMessagesByChatIdAction } from '../../handles'
import { fetchMessages, FetchMessagesResponse } from '../_http/chat'

const MESSAGES_LIMIT = 50

export function* loadMessagesByChatIdSaga(action: ReturnType<typeof loadMessagesByChatIdAction.request>) {
  const { chatId, ownerId } = action.payload
  try {
    const { messages, hasMore }: FetchMessagesResponse = yield fetchMessages({
      chatId,
      ownerId,
      queryLimit: MESSAGES_LIMIT
    })
    yield put(setHasMoreMessages({ state: hasMore }))
    yield put(loadMessagesByChatIdAction.success(messages))
  } catch (error) {
    yield put(loadMessagesByChatIdAction.failure(error))
  }
}
